import { useCallback, useMemo } from 'react';
import { useListGroupsQuery } from '@services/groupsApi';
import type { Group } from '@/types';

/** Group id -> county/group name lookup (cached list of every county group). */
export const useCountyName = () => {
  const { data } = useListGroupsQuery();
  const byId = useMemo(
    () => new Map((data || []).map((g: Group) => [Number(g.pvGroupID), g])),
    [data],
  );
  const nameOf = useCallback(
    (id?: number | string | null): string => {
      if (id === null || id === undefined || id === '') return '';
      return byId.get(Number(id))?.pvGroupName || '';
    },
    [byId],
  );
  return {
    groups: data || [],
    nameOf,
    titleOf: (id?: number | null) => byId.get(Number(id))?.pvGroupTitle || nameOf(id),
  };
};
